module.exports = __webpack_public_path__ + "static/20141025_094748-c910e2dc83e8d932cd69e267bd365a05.jpg";